export const emptyWhaleTransaction =
  [{
    txtime: "",
    action: "",
    asset: "",
    amount: "",
    usdvalue: "",
    address: "",
    tx: "",
    id: ""
  }];

/* example
{"id": "05d3c225d196", 
"txtime": 1676687727, 
"tx": "0xcf5de83360cd34cf42da9ab7cc3dc0d9976a42564e6ad59f8a4d979496bf7b1b", 
"action": "supply", 
"address": "0xfa3ccb086bf371a2ff33db8521be47c5b4b9d10e", 
"addressname": "Beefy Finance", 
"asset": "BNB", 
"amount": 3236.7669122725624, 
"usdvalue": 1024469.0954033887}
*/
